import React from 'react'
import { useIntl } from 'react-intl'

import {
  Panel,
  Title,
  TITLE_VARIANT_M,
  Text,
  SpacingVertical,
  SPACING_8
} from 'mailup-web-components'

const BoxNoSpamCheckOption = () => {
  const intl = useIntl()

  return (
    <Panel>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({
          id: 'Load.EmailCheckUp.SpamCheckNoSpamCheckNew'
        })}
      </Title>
      <SpacingVertical variant={SPACING_8} />
      <Text>
        {intl.formatMessage({
          id: 'Load.EmailCheckUp.SpamCheckBuySpamCheckNew'
        })}
      </Text>
    </Panel>
  )
}

export default BoxNoSpamCheckOption
